// extracted by mini-css-extract-plugin
export default {"relative":"InfiniteScrollRef_relative__brRHV","absolute":"InfiniteScrollRef_absolute__zFCZs"};